import moment from "moment";
import { TripDatesDto } from "../Global/models/TripDto";

export const formatToMonthRange = (dateRanges: TripDatesDto[]): string => {
  const sortedDates = dateRanges
    .flatMap(({ from, to }) => [new Date(from), new Date(to)])
    .sort((a, b) => a.getTime() - b.getTime());

  const startMonth = moment(sortedDates[0]).format("MMM");
  const endMonth = moment(sortedDates[sortedDates.length - 1]).format("MMM");

  if (startMonth === endMonth) {
    return `In ${startMonth}`;
  } else {
    return `${startMonth} - ${endMonth}`;
  }
};

export const formatTripDateRangeToDateAndMonth = (
  tripDates: TripDatesDto
): string => {
  const fromFormatted = moment(tripDates.from).format("D MMM");
  const toFormatted = moment(tripDates.to).format("D MMM");

  return `${fromFormatted} - ${toFormatted}`;
};

export const getCurrentAndNextThreeMonths = () => {
  const currentDate = moment();
  const months = [];

  for (let i = 0; i < 4; i++) {
    const nextMonth = currentDate.clone().add(i, "months");
    const formattedMonth = nextMonth.format("MMMM' YY");
    months.push({
      month: nextMonth.format("MMMM"),
      formattedMonth: formattedMonth,
    });
  }

  return months;
};

export const getAllMonths = () => {
  const currentDate = moment();
  const months = [];

  for (let i = 0; i < 12; i++) {
    const nextMonth = currentDate.clone().add(i, "months");
    const formattedMonth = nextMonth.format("MMMM' YY");
    months.push({
      month: nextMonth.format("MMMM"),
      formattedMonth: formattedMonth,
    });
  }

  return months;
};

export const containsMonth = (ranges: TripDatesDto[], month: string): boolean => {
  const monthNumber = moment().month(month).month(); // Get the numerical representation of the month

  for (const range of ranges) {
    const fromMonth = moment(range.from).month();
    const toMonth = moment(range.to).month();

    if (monthNumber >= fromMonth && monthNumber <= toMonth) {
      return true;
    }
  }

  return false;
};